export const getProjectNavigationPath = (caseId, isValidator = false, validationQueue = '') => {
  const normalizedCaseId = String(caseId ?? '').trim();
  if (!normalizedCaseId) {
    return isValidator ? '/validate' : '/';
  }

  const basePath = isValidator ? '/validate' : '/case';
  const normalizedQueue = ['split', 'normal', 'flow'].includes(validationQueue)
    ? validationQueue
    : '';
  return `${basePath}/${encodeURIComponent(normalizedCaseId)}${normalizedQueue ? `?queue=${normalizedQueue}` : ''}`;
};

/** Resolve a project's entry point using work that actually needs a review. */
export const getPendingValidationQueue = (summary) => {
  const splitPending = Number(summary?.split_pending_count || 0);
  if (splitPending > 0) return 'split';
  const normalPending = summary?.normal_pending_count === undefined
    ? Math.max(Number(summary?.pending_count || 0) - splitPending, 0)
    : Number(summary.normal_pending_count || 0);
  if (Number(summary?.has_event_confirmed_flow) === 1 && normalPending > 0) return 'normal';
  if (Number(summary?.flow_validation_pending_count || 0) > 0) return 'flow';
  return '';
};
